import React from 'react'

import '../styles/jumping-man.scss'

const JumpingMan = (props) => (
	<svg className="jumping-man" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
		 viewBox="260 370 90 100" >
		<g>
			<g>
				<path className="st0" d="M321.7,380c3.2,1.2,3.4,4.1,1.5,6.5c-4.6,6-8.9,12.1-13.4,18.1c-0.4,0.5-0.5,0.9-0.3,1.5
					c1.6,6.4,3.2,12.7,4.7,19.1c0.1,0.3,0.3,0.7,0.5,0.9c3.4,4.3,6.9,8.6,10.3,12.9c1.3,1.7,1.3,3.8-0.1,5.4c-4.3,5-8.6,10.1-13,15.1
					c-1.7,1.9-4.3,2.1-6.1,0.5c-1.8-1.6-2-4.2-0.3-6.2c3.3-3.8,6.6-7.7,9.9-11.5c0.2-0.2,0.4-0.5,0.6-0.8c-0.6-0.8-1.2-1.5-1.8-2.3
					c-1.9-2.4-3.8-4.8-5.8-7.2c-0.2-0.2-0.6-0.5-0.9-0.4c-0.5,0.1-1.2,0-1.4,0.8c-1.2,4.4-2.4,8.7-3.7,13.1c-0.7,2.6-2.6,3.7-5.3,3.3
					c-5.8-1-11.6-2-17.4-3.1c-2.1-0.4-3.5-1.7-3.8-3.5c-0.3-2,0.5-3.8,2.3-4.5c0.8-0.4,1.9-0.5,2.7-0.4c4.5,0.7,9,1.6,13.5,2.3
					c0.2,0,0.5,0.1,0.8,0.1c0.5-1.9,1.1-3.8,1.6-5.6c0.1-0.2,0-0.4-0.1-0.6c-1.8-7.3-3.6-14.5-5.4-21.8c-0.1-0.4-0.4-0.9-0.7-1.2
					c-6.5-6.6-13-13.3-19.5-19.9c-1-1-1.6-2.1-1.3-3.5c0.5-2.7,3.6-3.8,5.7-2.1c0.3,0.2,0.6,0.5,0.9,0.8c5.6,5.7,11.2,11.4,16.8,17.1
					c0.4,0.5,0.8,0.6,1.4,0.4c2.6-0.7,5.3-1.3,7.9-2c0.4-0.1,0.9-0.4,1.2-0.8c4.5-6.1,9.1-12.3,13.6-18.4c0.7-1,1.6-1.9,2.8-2.3
					C320.8,380,321.3,380,321.7,380z"/>
				<path className="jumping-man-head"  d="M304,393.1c0,4.1-3.3,7.3-7.4,7.3c-4.1,0-7.4-3.3-7.3-7.4c0-4,3.3-7.4,7.4-7.3
					C300.8,385.8,304,389.1,304,393.1z" />
			</g>
		</g>
	</svg>
)

export default JumpingMan;



// WEBPACK FOOTER //
// ./src/components/home/images/JumpingMan.jsx